export default "__VITE_ASSET__BEjIaJMX__"